// extracted by mini-css-extract-plugin
module.exports = {"AnswerItem":"_2E3aRuOAvALxwJ64TjxD0e","success":"_1LWwOWzK3fQBuVjeIfgivh","error":"_33P5DZUx4PqLBjnNHwOgLk"};